import { apiClient } from "@/API/axiosClient";
import { questions_urls } from "@/API/config";

export async function deleteQuestionUseCase(questionId) {
  const response = await apiClient.delete(questions_urls.delete(questionId));

  if (response.status !== 204) {
    throw new Error(`Suppression refusée (${response.status})`);
  }
}
